/** Cute two-tone notification chime via Web Audio API */
export function playNotificationSound() {
    try {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return;
        const ctx = new AudioCtx();

        const playTone = (freq, start, duration) => {
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.type = "sine";
            osc.frequency.value = freq;
            gain.gain.setValueAtTime(0, start);
            gain.gain.linearRampToValueAtTime(0.18, start + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.001, start + duration);
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.start(start);
            osc.stop(start + duration);
        };

        const now = ctx.currentTime;
        playTone(659.25, now, 0.12);
        playTone(880, now + 0.1, 0.14);
        playTone(1046.5, now + 0.22, 0.16);
        playTone(1318.51, now + 0.36, 0.28);

        setTimeout(() => ctx.close(), 900);
    } catch {
        /* ignore audio errors */
    }
}
